import { render, staticRenderFns } from "./AutoTexts.vue?vue&type=template&id=ec09ee48&"
import script from "./AutoTexts.vue?vue&type=script&lang=js&"
export * from "./AutoTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports